export default __webpack_public_path__ + "static/media/shapes-modularStone.fe7ed928.png";